import { render, staticRenderFns } from "./mark-detail-modal.vue?vue&type=template&id=a4a402ba"
import script from "./mark-detail-modal.vue?vue&type=script&lang=js"
export * from "./mark-detail-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports